import React from 'react';
import { Phone, Radio, Volume2, Bluetooth, Waves, Disc, Settings } from 'lucide-react';
import { services, businessInfo } from '../mockData';

const ServicesPage = () => {
  return (
    <div className="services-page">
      <section className="page-hero">
        <div className="page-hero-content">
          <h1 className="page-hero-title">Our Services</h1>
          <p className="page-hero-subtitle">
            Professional mobile car audio installation services delivered to your location
          </p>
        </div>
      </section>

      <section className="services-detail-section">
        <div className="services-detail-grid">
          {services.map((service) => {
            const Icon = require('lucide-react')[service.icon];
            return (
              <div key={service.id} className="service-detail-card">
                <div className="service-detail-image">
                  <img src={service.image} alt={service.title} />
                  <div className="service-detail-icon">
                    <Icon size={40} />
                  </div>
                </div>
                <div className="service-detail-content">
                  <h3 className="service-detail-title">{service.title}</h3>
                  <p className="service-detail-description">{service.description}</p>
                  <a href="#contact" className="service-detail-link">
                    Get a Quote →
                  </a>
                </div>
              </div>
            );
          })}
        </div>
      </section>

      <section className="services-cta">
        <div className="cta-content">
          <h2 className="cta-title">Ready to Upgrade Your Car Audio?</h2>
          <p className="cta-subtitle">
            Contact us today for professional mobile installation service
          </p>
          <a href={`tel:${businessInfo.phone}`} className="btn-primary btn-large">
            <Phone size={24} />
            Call {businessInfo.phone}
          </a>
        </div>
      </section>
    </div>
  );
};

export default ServicesPage;